import { createContext } from 'react-router';

import type { UserInfo } from '@/shared/types/user.types';

export const userContext = createContext<UserInfo | null>(null);
